import { useEffect, useState } from "react"
import Helmet from "@helpers/Helmet"

import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/pictures"

import { Header } from "@components/header"
import {
  LandingPageBanner,
  FaqContainer,
  LandingPageCta,
  CompanyRow,
  TestimonialRow,
} from "@modules/landing-page/components"

import { DynamicHelmet } from "@interfaces/misc"
import { School } from "@interfaces/school"
import { HariseninFooter } from "@components/harisenin/HariseninFooter"
import { useScreenSize } from "@lib/hooks/useScreenSize"
import ProgramRow from "../components/ProgramRow"
import dynamic from "next/dynamic"

const FloatingWhatsApp = dynamic(() => import("@harisenin/react-floating-whatsapp"), { ssr: false })

export interface LandingPageProps {
  meta: DynamicHelmet
  bootcamps: School[]
  proClasses: School[]
  codingCamps: School[]
}

export default function LandingPage({
  bootcamps,
  proClasses,
  codingCamps,
  meta,
}: LandingPageProps) {
  const [isTransparent, setIsTransparent] = useState(true)

  const { screenWidth } = useScreenSize()

  useEffect(() => {
    window.addEventListener("scroll", trackScrolling)

    return () => {
      window.removeEventListener("scroll", trackScrolling)
    }
  }, [])

  function isBottom(el: HTMLElement) {
    const eleTop = el.getBoundingClientRect().top

    return eleTop < 60
  }

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("header2")
    const isBtm = isBottom(wrappedElement)

    if (isBtm) {
      setIsTransparent(false)
    } else {
      setIsTransparent(true)
    }
  }

  return (
    <>
      <FloatingWhatsApp
        phoneNumber="+6281312117711"
        accountName="Customer Services"
        allowClickAway
        notification
        notificationDelay={30000}
      />
      <Helmet
        isIndexed
        image={`${HARISENIN_PUBLIC_PAGE_ASSETS}/homepage_banner_2.png`}
        title={meta?.title ?? "Sekolah online yang  membantu mewujudkan karir dan masa depanmu."}
        description={
          meta?.description ??
          "Bersama harisenin.com, pelajari keahlian dan rahasia sukses untuk memulai perjalanan karier dan masa depan impianmu."
        }
      />
      <Header transparent={isTransparent} isNotSticky />

      <main className="font-inter">
        <LandingPageBanner />
        <ProgramRow screenWidth={screenWidth} type="BOOTCAMP" initialData={bootcamps} />
        <ProgramRow screenWidth={screenWidth} type="CODING_CAMP" initialData={codingCamps} />
        <ProgramRow screenWidth={screenWidth} type="PRO_CLASS" initialData={proClasses} />
        <CompanyRow screenWidth={screenWidth} />

        <TestimonialRow screenWidth={screenWidth} />

        <FaqContainer />

        <LandingPageCta />
      </main>

      <HariseninFooter />
    </>
  )
}
